dayContainer.$inject = ["API_URL", "$rootScope", "$timeout", "FixedHeadingService"];
angular.module('directive.dayContainer', []).directive('dayContainer', dayContainer);

function dayContainer(API_URL, $rootScope, $timeout, FixedHeadingService) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: smooth.calendar_url + '/partials/directives/day-container.html',
    scope: {
      day: '=',
      parentScope: '='
    },
    link: function link(scope, elem, attrs) {
      scope.timeSettings = $rootScope.timeSettings;
      $timeout(function () {
        // Sort headings when the columns render
        FixedHeadingService.fixHeading(); // Attach fixHeading to scroll event

        $(window).scroll(FixedHeadingService.fixHeading);
      }, 0);
    }
  };
}